import { UserTreatmentDTO } from './UserTreatmentDTO'
import { UserTreatmentWithTreatmentNameDTO } from './UserTreatmentWithTreatmentNameDTO'

export class UserTreatmentWithTreatmentName {
  private _userTreatment: UserTreatmentDTO
  private _name: string
  private _dose?: number
  private _unit?: number

  constructor(p: UserTreatmentWithTreatmentNameDTO) {
    this._userTreatment = p.userTreatment
    this._name = p.name
    this._dose = p.dose
    this._unit = p.unit
  }

  get userTreatment(): UserTreatmentDTO {
    return this._userTreatment
  }

  get name(): string {
    return this._name
  }

  get dose(): number | undefined {
    return this._dose
  }

  get unit(): number | undefined {
    return this._unit
  }
}
